export default __webpack_public_path__ + "static/media/leg-left-inside.1a53a378.png";